export default "__VITE_ASSET__Djpr4V4r__"